import React, { useEffect } from 'react';
import '../styling/formChoice.css';

const FormChoice = ({ handleFormChoice }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="form-choice">
      <h1>Choose a Form</h1>
      <div className="button-container">
        <button onClick={() => handleFormChoice('Anesthesia')}>Anesthesia Form</button>
        <button onClick={() => handleFormChoice('Dental Implant')}>Dental Implant Form</button>
        <button onClick={() => handleFormChoice('Dentoalveolar Surgery')}>Dentoalveolar Surgery Form</button>
        <button onClick={() => handleFormChoice('Needle Stick Injury')}>Needle Stick Injury Form</button>
      </div>
    </div>
  );
};

export default FormChoice;

